import { CBContext, CBEventInfo } from "../../codebricks-runtime/CBModels";
import { Clone } from "../../codebricks-runtime/CBUtil";
import { CodeBrick } from "../../codebricks-runtime/CodeBrick";

export class ci_global_event_webcomponent extends HTMLElement {
    ci: web_ci_global_event | undefined;
    constructor() {
        super();
    }
    connectedCallback() {
        if(!this.ci) {
            let context = (globalThis as any).codebricks_context;
            let cid = this.getAttribute('cid') as string;
            let name = this.getAttribute('name') as string;
            let dc = this.getAttribute('dc') as string;
                let idx = this.getAttribute('idx') as string;
                let container_id = this.getAttribute('container_id') as string;
            this.ci = new web_ci_global_event(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if(this.ci) {
            this.ci.destructor();
        }
    }
}
customElements.define('ci-global-event', ci_global_event_webcomponent);

export class web_ci_global_event extends CodeBrick {

    element: HTMLElement;

    listening = {} as { [event:string] : any };

    constructor(context: CBContext, cid:string, name: string, dc: string, idx: number, container_id: string, element: HTMLElement) {
        super(context, cid, name, dc, idx, container_id);
        this.element = element;

        if(!(<any>window).ci_global_event_send) {
            (<any>window).ci_global_event_send = async function(event_name: string, event_data: any) {

                (<any>window).ci_global_event_data = (<any>window).ci_global_event_data || {};
                (<any>window).ci_global_event_data[event_name] = Clone(event_data);

                //console.log("ci_global_event_send "+event_name);
                if((<any>window).codebricks_context.global_event_listeners &&
                (<any>window).codebricks_context.global_event_listeners[event_name]) {
                    for(let handler of (<any>window).codebricks_context.global_event_listeners[event_name]) {
                        //console.log("ci_global_event_send call handler " +event_name+" "+JSON.stringify(event_data));
                        await handler(event_data);
                    }
                }
            }
        }
    }

    async cb_event(input: string, cfg: any, info: CBEventInfo): Promise<any> {
        if(input == "send") {
            if(cfg && cfg.event_name) {

                //console.log("ci-global-event "+this.brick_id+" global-send "+info.source+"->"+ cfg.event_name);

                await (<any>window).ci_global_event_send(cfg.event_name, cfg.event_data);
            }
        }
        else if(input == "listen") {
            if(cfg && Array.isArray(cfg)) {
                (<any>window).codebricks_context.global_event_listeners = (<any>window).codebricks_context.global_event_listeners || {};
                let self = this;
                for(let event_name of cfg) {
                    (<any>window).codebricks_context.global_event_listeners[event_name] = (<any>window).codebricks_context.global_event_listeners[event_name] || [];
                    
                    if(self.listening[event_name]) {
                        //console.log("ci-global-event already listening to "+ event_name);
                        continue;
                    }

                    //console.log("ci-global-event "+this.brick_id+" register listen "+info.source+"->"+ event_name);
                    let event_name_c = event_name;

                    self.listening[event_name] = async function(data: any) {
                        let emit_data = {} as any;
                        emit_data["@" + event_name_c] = data;

                        //console.log("ci-global-event "+self.brick_id+" handler_run "+info.source_brick_id+"->"+event_name_c+ " "+JSON.stringify(emit_data));

                        await self.cb_emit(emit_data);
                    } as any;
                    
                    (<any>window).codebricks_context.global_event_listeners[event_name_c].push(self.listening[event_name]);

                    //If event has finred, and someone subscribes after that, they must get the event when they subscribe. This solves race conditions.
                    if((<any>window).ci_global_event_data && (<any>window).ci_global_event_data[event_name]) {
                        let emit_data = {} as any;
                        emit_data["@" + event_name_c] = (<any>window).ci_global_event_data[event_name];

                        return emit_data;
                    }
                }
            }
        }
    }
    cb_validate(): boolean {
        return this.validate_sources("");
    }
    cb_initial_cement(cements: { [child_idx: number]: any }) {
    }
    cb_update_cement(child_idx: number, cement: any, row_idx: number) {
    }
    cb_status(status: string): void {
        this.emit_state(status);
    }
    cb_snapshot() {}

    async cb_unload() {
        //console.log("ci-global-event "+this.brick_id+" UNLOAD ");
        let self = this;
        for(let event_name in self.listening) {
            let fun = self.listening[event_name];
            for(let i = (<any>window).codebricks_context.global_event_listeners[event_name].length - 1; i >=0; i--) {
                let gfun = (<any>window).codebricks_context.global_event_listeners[event_name][i];
                if(fun == gfun) {
                    //console.log("ci-global-event UNLOAD "+i);
                    (<any>window).codebricks_context.global_event_listeners[event_name].splice(i, 1);
                }
            }
        }
    }
}